import React from "react";
import {
  ResultsTextInput,
  ResultsLayerInfo,
} from "../../../../../../Components/Map/Form/Select";
import { ResultsStepInput } from "../../../../../../Components/Map/Form/Select";
import { ChromePicker } from "react-color";
import {
  setLayerOpacity,
  setLayerColorPalette,
} from "../../../../../../redux/actions/resultsActions";
import { chromePickerStyle } from "../CategoryLayer/CategoryLayer";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import "../../../../../../Components/Common/PaletteDropdown/index.scss";

class IsolinesLayer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isColorPickerOpen: false,
    };

    this.openColorPicker = this.openColorPicker.bind(this);
    this.closeColorPicker = this.closeColorPicker.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
    this.handleOpacityChange = this.handleOpacityChange.bind(this);
  }

  openColorPicker() {
    this.setState({ isColorPickerOpen: true });
  }

  closeColorPicker() {
    this.setState({ isColorPickerOpen: false });
  }

  handleColorChange(e) {
    const leafletId = this.props.isolinesLeafletArrayId.find(
      (x) => x.isolinesLayerName === this.props.jsonOriginPartSelected.name
    ).leafletId;

    this.props.setLayerColorPalette(e.hex);

    const layer = this.props.mapRef.leafletElement._layers[leafletId];

    if (layer) {
      layer.setStyle({
        color: e.hex,
      });
    }
  }

  handleOpacityChange(e) {
    const leafletId = this.props.isolinesLeafletArrayId.find(
      (x) => x.isolinesLayerName === this.props.jsonOriginPartSelected.name
    ).leafletId;
    const opacity = e.target.value;

    this.props.setLayerOpacity(opacity);

    const layer = this.props.mapRef.leafletElement._layers[leafletId];
    if (layer) {
      layer.setStyle({
        opacity: opacity,
      });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <ResultsTextInput
          label={t("LayerName")}
          value={t(this.props.jsonOriginPartSelected.name)}
          visSettings
          disabled
        />
        <hr
          className="raster-settings-ruler"
          style={{ width: "300px", marginBottom: "0px" }}
        />
        <h5
          className="raster-settings-header"
          style={{ marginBottom: "16px", marginTop: "14px" }}
        >{`${t("Statistics")}`}</h5>
        <ResultsLayerInfo
          label={t("Minimum")}
          value={this.props.jsonOriginPartSelected.stat_min}
          style={{ borderRadius: "2px 2px 0px 0px" }}
          visSettings
        />
        <ResultsLayerInfo
          label={t("25%Quantile")}
          value={this.props.jsonOriginPartSelected.stat_q25}
          visSettings
        />
        <ResultsLayerInfo
          label={t("Median")}
          value={this.props.jsonOriginPartSelected.stat_median}
          visSettings
        />
        <ResultsLayerInfo
          label={t("Mean")}
          value={this.props.jsonOriginPartSelected.stat_mean}
          visSettings
        />
        <ResultsLayerInfo
          label={t("75%Quantile")}
          value={this.props.jsonOriginPartSelected.stat_q75}
          visSettings
        />
        <ResultsLayerInfo
          label={t("Maximum")}
          value={this.props.jsonOriginPartSelected.stat_max}
          style={{ borderRadius: "0px 0px 2px 2px" }}
          visSettings
        />
        <hr
          className="raster-settings-ruler"
          style={{ width: "300px", marginBottom: "8px" }}
        />
        <h5
          className="raster-settings-header"
          style={{ marginBottom: "10px", marginTop: "6px" }}
        >
          Isolines
        </h5>

        <ResultsStepInput
          label={t("Opacity")}
          value={this.props.jsonOriginPartSelected.plot_opacity}
          style={{ borderRadius: "2px", height: "28px" }}
          onChange={this.handleOpacityChange}
          min={0}
          max={1}
          step={0.1}
          visSettings
          onBlur={(e) => {
            if (
              e.target.value === "" ||
              Number(e.target.value) < 0 ||
              Number(e.target.value) > 1
            ) {
              this.props.setLayerOpacity(1);
            }
          }}
        />
        <div
          className={`form-group form-results-group`}
          style={{
            justifyContent: "space-between",
          }}
        >
          <label
            key={"isolines-color"}
            style={{ width: "auto" }}
            className={`form-label form-results-label`}
          >
            {t("Color")}
          </label>
          <div
            onClick={() => this.openColorPicker()}
            style={{
              width: "250px",
              height: "27px",
              backgroundColor: `${this.props.jsonOriginPartSelected.plot_color}`,
              borderRadius: "2px",
              cursor: "pointer",
              border: "1px solid #999999",
            }}
          />
        </div>
        {this.state.isColorPickerOpen && (
          <div
            style={
              !this.props.jsonOriginPartSelected.plot_color
                ? {
                    position: "fixed",
                    zIndex: "2",
                    top: `${420}px`,
                    right: "110px",
                  }
                : {
                    position: "fixed",
                    zIndex: "2",
                    top: `${300}px`,
                    right: "110px",
                  }
            }
            onDoubleClick={this.closeColorPicker}
          >
            <div style={chromePickerStyle} onClick={this.closeColorPicker} />
            <ChromePicker
              color={{ hex: this.props.jsonOriginPartSelected.plot_color }}
              onChange={(e) => this.handleColorChange(e)}
            />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    mapRef: state.results.mapRef,
    jsonOriginPartSelected: state.results.jsonOriginPartSelected,
    isolinesLeafletArrayId: state.results.isolinesLeafletArrayId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLayerOpacity: (payload) => dispatch(setLayerOpacity(payload)),
    setLayerColorPalette: (payload) => dispatch(setLayerColorPalette(payload)),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(IsolinesLayer)
);
